module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-lueftung-kaelte-klima-616b5be159a5147924d639c9ae1c30cb.svg";